import { IconCash } from '@tabler/icons-react';

import { TimeSeriesChart } from '@charts';

export default function RevenueChart({ report, timeSeries, reportLoading, currency = 'BRL' }) {
    return (
        <TimeSeriesChart
            title={`Receita no período (${currency})`}
            icon={<IconCash size={15} />}
            timeSeries={timeSeries}
            valueType="money"
            currency={currency}
            report={report}
            reportLoading={reportLoading}
        />
    );
}
